<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="false" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.newRecord.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.newRecord.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          input(type="file" id="file" ref="file" v-on:change="handleFileUpload()" accept="application/pdf")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(:label='$t("projects.type")', v-model='newRecord.type' :placeholder='$t("projects.type_placeholder")')
            vm-select-item(:value='1', text='Structure, Miscellaneous, Mounting, Sheet')
            vm-select-item(:value='2', text='Job File')
            vm-select-item(:value='3', text='Quotation Cano Steel To Client')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("projects.comments_placeholder")' v-model="newRecord.comments" :label='$t("projects.comments")')
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('QuotationFiles')

export default {
  name: 'ModalQuotationFiles',
  props: {
    newRecord: {
      type: Object
    },
    isAdd: {
      default: true,
      type: Boolean
    },
    project: {
      default: null,
      type: Number
    }
  },
  validations () {
    return {
      newRecord: {
        type: {
          required
        },
        file: {
          required: requiredIf(function () { return this.fileValidate })
        }
      }
    }
  },
  data: () => ({
    file: ''
  }),
  computed: {
    ...mapGetters([
      'isModalVisible',
      'quotationFilesCatalog'
    ]),
    fileValidate () {
      return this.file.length < 1
    },
    getTitle () {
      return this.isAdd ? this.$t('strings.add') : this.$t('strings.edit')
    }
  },
  methods: {
    ...mapActions([
      'addQuotationFile',
      'editQuotationFile',
      'deleteQuotationFile',
      'setModalVisible',
      'loadCatalog'
    ]),
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    async saveRecord () {
      this.isAdd ? await this.addQuotationFile({ file: this.file, newRecord: this.newRecord, project_id: this.project }) : await this.editQuotationFile({ file: this.file, newRecord: this.newRecord, project_id: this.project })
      this.file = ''
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>
